export function includes<T, S extends T>(
  haystack: readonly S[],
  needle: T
): needle is S {
  const _haystack: readonly T[] = haystack;
  return _haystack.includes(needle);
}
